import { Component } from '@theme/component';

/**
 * @property {HTMLAnchorElement|HTMLButtonElement} button - The clickable element
 */
class EscSortByControl extends Component {
  requiredRefs = ['button'];

  get sectionId() {
    const id = this.getAttribute('section-id');
    if (!id) throw new Error('Section ID is required'); 
    return id;
  }

  get section() {
    return document.querySelector(`#shopify-section-${this.sectionId}`);
  }

  get newURL() {
    const url = new URL(window.location.href);

    if (!this.dataset.sortBy) {
      return url;
    }

    url.searchParams.set('sort_by', this.dataset.sortBy)
    
    return url;
  }

  /** @type {Element|null} */
  #prefetchedSection = null

  connectedCallback() {
    super.connectedCallback();

    this.#addListeners() 
  }

  #addListeners() {
    this.refs.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.#toggleFilter();
    });

    this.addEventListener('mouseover', () => {
      this.#prefetch();
    });

    const summaryElement = this.closest('summary');

    if (summaryElement) {
      if (summaryElement.matches('[open]')) {
        this.#prefetch();
      }

      summaryElement.addEventListener('toggle', () => {
        if (summaryElement.matches('[open]')) {
          this.#prefetch();
        }
      })
    } else {
      this.#prefetch();
    }
  }

  #toggleFilter() {
    if (!this.section) {
      return;
    }

    const mainElement = document.querySelector('.esc-collection__main');
    mainElement?.classList.add('esc-collection__main--loading');
    
    this.querySelector('.icon-checkbox')?.classList.toggle('icon-checkbox--checked');

    if (this.#prefetchedSection) {
      history.replaceState('', '', this.newURL);
      this.section.innerHTML = this.#prefetchedSection.innerHTML;
      mainElement?.classList.remove('esc-collection__main--loading');
      this.#prefetch();
    } else {
      this.#prefetch().then(() => this.#toggleFilter());
    }
  }

  #prefetch() {
    return fetch(this.newURL)
      .then((response) => response.text())
      .then((responseURL) => {
        const wrapper = document.createElement("div")
        wrapper.innerHTML = responseURL;

        this.#prefetchedSection = wrapper.querySelector(`#shopify-section-${this.sectionId}`);
      })
  }
}

if (!customElements.get('esc-sort-by-control')) {
    customElements.define('esc-sort-by-control', EscSortByControl);
}